import type { DummyFoods } from './dummyFoods'

export const nutMilk: DummyFoods = {
  'Nut milk': {
    Almond: ['Almond milk'],
    Cashew: ['Cashew milk'],
    Coconut: ['Coconut milk'],
    Flax: ['Flax milk'],
    Hemp: ['Hemp milk'],
    'Macadamia nut': ['Macadamia nut milk'],
    Oat: ['Oat milk'],
    Rice: ['Rice milk'],
    Soy: ['Soy milk'],
  },
}
